<script setup>
import { router } from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue';
import Welcome from '@/Pages/Dashboard/Welcome.vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
import ActionsStarredWidget from '@/Pages/Dashboard/ActionsStarredWidget.vue';
import ActionsAssignedWidget from '@/Pages/Dashboard/ActionsAssignedWidget.vue';
import LeaderboardWidget from '@/Pages/Dashboard/LeaderboardWidget.vue';
import AwardsProgressWidget from '@/Pages/Dashboard/AwardsProgressWidget.vue';
import PreviousToolkitsWidget from '@/Pages/Dashboard/PreviousToolkitsWidget.vue';
import CarbonSavingsWidget from './Dashboard/CarbonSavingsWidget.vue';
import TeamCustomQuestions from './Teams/Partials/TeamCustomQuestions.vue';


const props = defineProps({
        toolkit: Object,
        awards: Object,
        actions: Array,
        loggedInUserId: Number,
        currentToolkitTeams: Object,
        currentUserTeam: Number,
        currentTeamFull: Object,
        activeToolkits: Array,
        previousToolkits: Array,
        loggedInUser: Object,
        newToolkitForTeam: Boolean,
    });

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

</script>

<template>
    <AppLayout title="Dashboard">

       <div class="container flex flex-col justify-between w-full mx-auto lg:flex-row">

            <div id="sos-programme-dashboard-sidebar" class="order-2 w-full min-h-screen p-10 pt-5 lg:order-1 lg:w-1/4 xl:w-1/5">
                <DashboardSidebar :programme="programme" :organisation="organisation" />
            </div>

             <div id="sos-programme-dashboard-content" class="order-1 w-full lg:order-2 lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <h2 class="pt-5 pl-10 dashboard-title">
                        {{$t('dashboard.title')}}
                    </h2>
                    <div class="flex flex-wrap p-10 pt-5 lg:pr-0">

                        <div class="widgets widgets-2-1" v-if="props.toolkit">
                            <div class="widgets-inner" :class="{'two-thirds': props.toolkit.show_leaderboard, 'w-full': !props.toolkit.show_leaderboard }">
                                <Welcome />
                                <ActionsStarredWidget :toolkit="props.toolkit" :actions="props.actions" />
                                <ActionsAssignedWidget :toolkit="props.toolkit" :actions="props.actions" :loggedInUserId="loggedInUserId" />

                            </div>
                            <div class="h-full widgets-inner one-third" v-if="props.toolkit.show_leaderboard">
                                <LeaderboardWidget
                                :toolkit="props.toolkit"
                                :actions="props.actions"
                                :currentToolkitTeams="props.currentToolkitTeams"
                                :currentUserTeam="props.currentUserTeam"
                                :loggedInUserId="loggedInUserId"
                                />
                            </div>
                        </div>

                        <div class="w-full widgets" v-if="props.toolkit">
                            <AwardsProgressWidget
                                :toolkit="props.toolkit"
                                :actions="props.actions"
                                :currentToolkitTeams="props.currentToolkitTeams"
                                :currentUserTeam="props.currentUserTeam"
                                :awards="props.toolkit.awards"
                                :loggedInUserId="loggedInUserId"
                             />
                        </div>

                        <div class="w-full widgets" v-if="!props.toolkit">
                            <div class="widgets-inner">
                                <Welcome />
                                <div class="w-full py-4 mb-5 text-center rounded-lg lg:px-4" style="background-color: #3d5567;" v-if="props.newToolkitForTeam">
                                    <a :href="route(urlNamePrefix+'toolkit.view')">
                                        <div class="flex items-center p-2 leading-none text-indigo-100 lg:rounded-full lg:inline-flex" style="background-color: #3d5567;" role="alert">
                                            <span class="flex px-2 py-1 mr-3 text-xs font-bold uppercase bg-green-500 rounded-full">{{$t('dashboard.widgets.new_toolkit.new')}}</span>
                                            <span class="flex-auto mr-2 font-semibold text-left">{{$t('dashboard.widgets.new_toolkit.content')}}</span>
                                            <svg class="w-4 h-4 opacity-75 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="w-full widgets carbon-savings" v-if="toolkit && toolkit.display_carbon_savings && currentTeamFull.enable_carbon_savings">
                            <CarbonSavingsWidget
                                :toolkit="props.toolkit"
                                :currentToolkitTeams="props.currentToolkitTeams"
                                :currentUserTeam="props.currentUserTeam"
                                :activeToolkits="props.activeToolkits"
                                :previousToolkits="props.previousToolkits"
                                :loggedInUserId="loggedInUserId"
                                :loggedInUser="loggedInUser"
                             />
                        </div>

                        <div class="w-full widgets">
                            <PreviousToolkitsWidget
                                :toolkit="props.toolkit"
                                :currentToolkitTeams="props.currentToolkitTeams"
                                :currentUserTeam="props.currentUserTeam"
                                :activeToolkits="props.activeToolkits"
                                :previousToolkits="props.previousToolkits"
                                :loggedInUserId="loggedInUserId"
                                :loggedInUser="loggedInUser"
                             />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
